//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Badge extends React.Component {
  // to-do: make badge more generic (not only attached to recommendations)
  render() {
    const { status, className, textOnly, t } = this.props;
    const componentClasses = classNames(
      styles.Badge,
      styles[status.className],
      {
        [className]: className,
      },
      { [styles.TextOnly]: textOnly }
    );

    return (
      <div className={componentClasses}>
        {!textOnly && <div className={styles.BadgeIndicator}></div>}
        <span>{t(status.i18nKey)}</span>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Badge);
